export { default } from "./EliminaCategorias";
